import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/auth-context'

interface ProtectedRouteProps {
  children: ReactNode
  allowedRoles?: string[]
  redirectTo?: string
}

export function ProtectedRoute({ 
  children, 
  allowedRoles = ['super_admin', 'admin', 'auditor', 'employee', 'manager', 'waiter', 'receptionist'], 
  redirectTo = '/my-account' 
}: ProtectedRouteProps) {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  // Show loading while checking auth
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-600"></div>
      </div>
    )
  }

  // Redirect to landing page if not authenticated
  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />
  }

  // Check if user role is allowed
  const userRole = user.role || 'guest'
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}